<template>
  <nav
    class="
      fixed left-0 top-0 z-30 flex w-full select-none items-center justify-start bg-white py-6
      pr-container-mobile-level-1 text-lg
      teacher:text-violet-text
      student:text-white
      lg:pr-container-desktop-level-2
    "
    role="navigation"
  >
    <div
      class="
        mr-auto shrink-0.5 grow-0 pl-container-mobile-level-1 pr-4
        md:basis-container-desktop-level-4
        lg:pl-container-desktop-level-2
      "
    >
      <DynLink
        :to="auth.homepage"
        aria-label="Dashboard"
        class="
          shrink-0 grow-0 ring-offset-8
          focus:outline-none
          focus-visible:ring-2 focus-visible:ring-focusTeacher
        "
      >
        <IconLogo class="h-7" :type="light ? 'invert' : 'teacher'" />
      </DynLink>
    </div>

    <slot />
  </nav>
</template>

<script setup lang="ts">
defineProps<{ light?: boolean }>()

const auth = useAuthStore()
</script>
